import script from "./LedgerAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./LedgerAccount.vue?vue&type=script&setup=true&lang=ts"

import "./LedgerAccount.vue?vue&type=style&index=0&id=fa8490c8&scoped=true&lang=css"
import "./LedgerAccount.vue?vue&type=style&index=1&id=fa8490c8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa8490c8"]])

export default __exports__